import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';
import Icon from '../Icon/Icon.js';
import i18n from '../../lang/i18n/index.js';
import { safeRest } from '../../utils/functions.js';
import safeCustomStyle from '../../utils/safeCustomStyle.js';
import { TextLinkWrapper } from './styledComponents.js';
import useDerivedState from '../../hooks/useDerivedState.js';
import useId from '../../hooks/useId.js';
import useTheme from '../../hooks/useTheme.js';
import useLang from '../../hooks/useLang.js';

var _excluded = ["id", "as", "to", "customStyle", "children", "isExternal", "isDocument"];
var TextLink = function TextLink(_ref) {
  var controlledId = _ref.id,
    Component = _ref.as,
    to = _ref.to,
    customStyle = _ref.customStyle,
    children = _ref.children,
    isExternal = _ref.isExternal,
    isDocument = _ref.isDocument,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useDerivedState = useDerivedState(useId('textlink-id-'), controlledId),
    _useDerivedState2 = _slicedToArray(_useDerivedState, 1),
    id = _useDerivedState2[0];
  var safeProps = safeRest(rest);
  var _safeCustomStyle = safeCustomStyle(customStyle),
    linkStyle = _safeCustomStyle.linkStyle;
  var theme = useTheme();
  var lang = useLang();
  var linkProps = Component === 'a' ? {
    href: to
  } : {
    to: to,
    target: '_self'
  };
  return /*#__PURE__*/React.createElement(TextLinkWrapper, {
    linkStyle: linkStyle,
    theme: theme
  }, /*#__PURE__*/React.createElement(Component, _extends({
    "aria-label": isExternal ? "".concat(children, " ").concat(i18n[lang].textLink.externalLinkText) : children,
    id: id,
    target: isExternal || isDocument ? '_blank' : '_top',
    rel: isExternal ? 'noopener noreferrer' : undefined
  }, linkProps, safeProps), children, isExternal && /*#__PURE__*/React.createElement(Icon, {
    "data-testid": "external-icon-test-id",
    manulifeName: "external",
    fill: theme.colorPalette.primaryColors.main.shade_link,
    color: "transparent"
  })));
};
process.env.NODE_ENV !== "production" ? TextLink.propTypes = {
  /** ID is required for Automated Testing, Google analytics and Google Tag Manager */
  id: PropTypes.string,
  /** component to use as TextLink ('a' or Link from react-router-dom) */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** url (by default maps to href) or url/object/function (when using Link from react-router-dom) */
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]),
  /** Flag to create external link that opens in new tab */
  isExternal: PropTypes.bool,
  /** Flag to indicate a document link that opens in a new tab */
  isDocument: PropTypes.bool,
  /** Content for the link */
  children: PropTypes.node.isRequired,
  /** Style overrides */
  customStyle: PropTypes.shape({
    linkStyle: PropTypes.object
  })
} : void 0;
TextLink.defaultProps = {
  id: undefined,
  as: 'a',
  to: undefined,
  isExternal: false,
  isDocument: false,
  customStyle: {
    linkStyle: {}
  }
};
var TextLink$1 = TextLink;

export { TextLink$1 as default };
